import _objectWithoutProperties from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["keepValuesOnReset", "outstandingChanges", "plotData", "loading", "error"];
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { SAVE_CONFIG } from 'redux/actionTypes/componentConfig';
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import endUserMessages from 'utils/endUserMessages';
import { permissions } from 'const';
import { getHasPermissions } from 'redux/selectors';
var savePlotConfig = function savePlotConfig(experimentId, plotUuid) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getState$componentCo, keepValuesOnReset, outstandingChanges, plotData, loading, error, content;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (getHasPermissions(null, permissions.WRITE)(getState())) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            // Do not save the 'outstandingChanges' state to the database.
            // Do not save the 'plotData' state to the database because it is not managed by the UI.
            // Do not save loading and error as it they are states in the UI.
            _getState$componentCo = getState().componentConfig[plotUuid], keepValuesOnReset = _getState$componentCo.keepValuesOnReset, outstandingChanges = _getState$componentCo.outstandingChanges, plotData = _getState$componentCo.plotData, loading = _getState$componentCo.loading, error = _getState$componentCo.error, content = _objectWithoutProperties(_getState$componentCo, _excluded);
            _context.prev = 3;
            _context.next = 6;
            return fetchAPI("/v2/experiments/".concat(experimentId, "/plots/").concat(plotUuid), {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(content)
            });
          case 6:
            dispatch({
              type: SAVE_CONFIG,
              payload: {
                plotUuid: plotUuid,
                success: true
              }
            });
            _context.next = 13;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            handleError(_context.t0, endUserMessages.ERROR_SAVING_PLOT_CONFIG);
            dispatch({
              type: SAVE_CONFIG,
              payload: {
                plotUuid: plotUuid,
                success: false
              }
            });
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 9]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default savePlotConfig;